<div class="scenarios mtl">
  <div class="recommanded">Solution recommandée</div>
  <div
    class="scenarios-body"
    prSwipe
    (onSwipeLeft)="display('previous')"
    (onSwipeRight)="display('next')"
  >
    @for (row of rows; track row; let first = $first; let i = $index) {
      <div class="scenario-row" [ngClass]="{ 'scenario-header': first }">
        <div class="scenario-cell scenario-row-label border-none">
          <pr-label
            [name]="row.icon"
            [width]="18"
            [height]="18"
            [tooltip]="row.tooltip"
            >{{ row.title }}</pr-label
          >
        </div>
        <div class="scenario-columns-wrapper">
          <div
            class="scenario-columns"
            [ngStyle]="{ transform: translation }"
            [ngClass]="row.label == 'header' ? 'bgColored' : ''"
          >
            @for (scenario of col; track scenario; let j = $index) {
              <div
                class="scenario-cell"
                (onSwipeRight)="display(j + 1)"
                [ngClass]="classBg(row, scenario)"
              >
                <pr-value
                  [type]="row.type"
                  [value]="val(row, scenario)"
                ></pr-value>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
  <div class="scenario-bullets">
    @for (scenario of col; track scenario; let i = $index) {
      <div
        class="scenario-bullet"
        (click)="display(i)"
        [ngClass]="{ active: i == numero }"
      ></div>
    }
  </div>
</div>
